import styled, { css } from 'styled-components/macro'

import { device, ColorsMap, FontWeightMap } from '@/utils/Theme'

export const Wrapper = styled.div`
  width: 72%;
  margin: 0 13%;

  @media (max-width: ${device.mobileS}) {
    width: 96%;
    margin: 0 2%;
  }
`
export const UpperPart = styled.div`
  display: flex;
  width: 100%;
  margin-bottom: 4rem;
  padding: 2rem;
  background-color: ${ColorsMap.white};

  @media (max-width: ${device.mobile}) {
    flex-direction: column;
  }
`

export const ProductImagesWrapper = styled.div`
  width: 55%;
  display: flex;
  flex-direction: column;
  margin: auto 0;
  margin-right: 2rem;
  @media (max-width: ${device.tablet}) {
    width: 50%;
  }
  @media (max-width: ${device.mobile}) {
    width: 100%;
  }
`

export const BrandWrapper = styled.div`
  margin-bottom: 1rem;
  opacity: 0.5;
  * {
    max-height: 1.5rem;
  }
`

type NextImagesWrapperProps = { hasSecondaryPhotos?: boolean }
export const NextImagesWrapper = styled.div<NextImagesWrapperProps>`
  ${({ hasSecondaryPhotos }) =>
    hasSecondaryPhotos
      ? css`
          display: flex;
          flex: 1;
          flex-direction: column;
        `
      : css`
          display: none;
        `};

  @media (max-width: ${device.tablet}) {
    order: 2;
    margin-top: 1rem;
  }
`

type NextImagesType = { showMoreImages: boolean }
export const NextImages = styled.div<NextImagesType>`
  display: ${(props) => {
    return props.showMoreImages ? 'initial' : 'none'
  }};
  @media (max-width: ${device.tablet}) {
    display: ${(props) => {
      return props.showMoreImages ? 'grid' : 'none'
    }};
    grid-template-columns: repeat(4, 1fr);
  }

  @media (min-width: ${device.tablet}) {
    &:nth-child(2) {
      display: ${(props) => {
        return props.showMoreImages ? 'grid' : 'none'
      }};
      grid-template-columns: repeat(4, 1fr);
    }
  }
`

export const NextImageWrapper = styled.div`
  display: flex;
  min-width: 3rem;
  max-width: 6rem;
  cursor: pointer;
  margin: 0.5rem 0;
  justify-content: center;
  align-items: center;
  border: 1px solid transparent;
  transition: 0.3s;

  &:hover {
    border-color: ${ColorsMap.primary};
  }

  @media (max-width: ${device.tablet}) {
    margin-right: 1rem;
  }

  * {
    max-height: 8rem;
  }
`
export const VisibleImages = styled.div`
  display: flex;

  @media (max-width: ${device.tablet}) {
    flex-direction: column;
  }
`

export const MainImage = styled.div`
  position: relative;
  cursor: pointer;
  flex: 4;
  display: flex;
  justify-content: center;
  align-items: start;
  max-height: 30rem;

  * {
    &:last-child {
      max-height: 30rem;
    }
  }

  @media (max-width: ${device.tablet}) {
    order: 1;
  }
`

export const SaleLogoWrapper = styled.div`
  position: absolute;
  top: 0;
  left: 0;
`

export const DescriptionWrapper = styled.div`
  padding: 2rem 0;
  width: 45%;
  margin: auto 0;
  @media (max-width: ${device.tablet}) {
    padding: 1rem 0;
    width: 50%;
  }
  @media (max-width: ${device.mobile}) {
    width: 100%;
    padding: 1rem;
  }
`

export const ProductMainDescription = styled.div`
  width: 100%;
  margin: 0 auto;
`

export const ProductDescription = styled.div`
  width: 100%;
  color: ${ColorsMap.brownishGrey};

  > * {
    white-space: break-spaces;
    &:not(:last-child) {
      margin-bottom: 0.5rem;
    }
  }
`

export const ButtonWrapper = styled.div`
  display: flex;

  @media (max-width: ${device.tablet}) {
    flex-direction: column;
  }
  * {
    margin: 0rem 1%;
    margin-top: 0.5rem;
    width: 100%;

    &:nth-child(1) {
      min-width: 11rem;
    }

    &:nth-child(2) {
      min-width: 10rem;
    }
  }
`

export const LowerPart = styled.div`
  display: flex;
  flex-direction: column;
  background-color: ${ColorsMap.white};
  padding: 2rem;
  margin-bottom: 4rem;
`

export const Details = styled.div`
  display: flex;
  justify-items: center;
  flex-wrap: wrap;
  margin-top: 2rem;
`

export const DetailBox = styled.div`
  line-height: 2rem;
  max-width: 18rem;
  margin: 2rem;

  @media (min-width: ${device.mobileS}) {
    margin: 2rem auto;

    &:nth-child(1) {
      margin-left: 0;
    }

    &:nth-child(3) {
      margin-bottom: 4rem;
    }
  }
`

type SliderWrapperProps = {
  open?: boolean
}
export const SliderWrapper = styled.div<SliderWrapperProps>`
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: ${ColorsMap.white};
  width: 70%;
  max-width: 40rem;
  min-height: 30rem;
  z-index: 2;
  ${({ open }) =>
    !open &&
    css`
      display: none;
    `};
`

export const Close = styled.div`
  position: absolute;
  top: 2rem;
  right: 2rem;
  cursor: pointer;
`

export const SizeWrapper = styled.div`
  margin: 2rem 0;
`

export const VariantWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
`

export const NotSelectable = styled.div`
  height: 0.1rem;
  width: 70%;
  background-color: ${ColorsMap.brownishGrey};
  position: absolute;
  top: 50%;
  display: none;
`

export const NameWrapper = styled.div`
  color: ${ColorsMap.brownishGrey};
  margin: 0 0.25rem;
`

export const Item = styled.div`
  display: flex;
  align-items: center;
  position: relative;
  min-width: 2rem;
  min-height: 2rem;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0.25rem;
`

export const RadioButtonLabel = styled.label`
  position: absolute;
  width: 100%;
  height: 100%;
  border: 1px solid ${ColorsMap.textDefault};
`

export const RadioButton = styled.input`
  position: absolute;
  opacity: 0;
  z-index: 1;
  cursor: pointer;
  width: 100%;
  height: 100%;

  &:hover ~ ${RadioButtonLabel} {
    border: 1px solid ${ColorsMap.brownishGrey};
    color: ${ColorsMap.brownishGrey};

    &::after {
      display: block;
      color: transparent;
    }
  }

  &:checked + ${Item} {
    border: 1px solid ${ColorsMap.brownishGrey};
    color: ${ColorsMap.brownishGrey};
  }

  &:checked + ${RadioButtonLabel} {
    border: 1px solid ${ColorsMap.brownishGrey};
    color: ${ColorsMap.brownishGrey};
    &::after {
      display: block;
      color: transparent;
    }
  }
  &:hover ~ ${NameWrapper} {
    color: ${ColorsMap.brownishGrey};
  }
  &:checked ~ ${NameWrapper} {
    color: ${ColorsMap.brownishGrey};
    font-weight: ${FontWeightMap.bold};
  }
`

export const SalePriceWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
`

export const Cross = styled.div`
  text-decoration: line-through;
  display: flex;
  align-items: center;
  color: ${ColorsMap.textDefault};
`

export const SalePercent = styled.div`
  border: 1px solid ${ColorsMap.textDefault};
  display: flex;
  align-items: center;
  padding: 0 1rem;
  border-radius: 2rem;
`

